import React from "react";

interface AuthInputProps {
  id: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  required?: boolean;
  minLength?: number;
  showToggle?: boolean;
  onToggle?: () => void;
  showPassword?: boolean;
  className?: string;
  autoFocus?: boolean;
  readOnly?: boolean;
}

export default function AuthInput({
  id,
  type,
  value,
  onChange,
  placeholder,
  required = false,
  minLength,
  showToggle = false,
  onToggle,
  showPassword = false,
  className = "",
  autoFocus,
  readOnly,
}: AuthInputProps) {
  const inputType = showToggle ? (showPassword ? "text" : "password") : type;

  return (
    <div className="relative">
      <input
        id={id}
        type={inputType}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 transition-all duration-200 border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-dark-400 ${showToggle ? "pr-10" : ""} ${className}`}
        required={required}
        minLength={minLength}
        autoFocus={autoFocus}
        readOnly={readOnly}
      />
      {showToggle && onToggle && (
        <button
          type="button"
          onPointerDown={onToggle}
          className="absolute inset-y-0 right-0 pr-3 flex items-center focus:outline-none text-gray-400 dark:text-dark-400 hover:text-gray-600 dark:hover:text-dark-200"
        >
          {showPassword ? (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
            </svg>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          )}
        </button>
      )}
    </div>
  );
}
